import { useScrollReveal } from "@/hooks/useScrollReveal";

const strengths = [
  {
    icon: "ri-shield-check-line",
    title: "大阪府公安委員会 正式認定",
    desc: "第1号・第2号警備の両方を取得。認定番号：第62003216号",
  },
  {
    icon: "ri-road-map-line",
    title: "高速道路・イベント警備に特化",
    desc: "新規参入が困難な高速道路警備を含む専門2分野で実績多数",
  },
  {
    icon: "ri-flashlight-line",
    title: "スピード対応",
    desc: "お見積もり・ご相談は最短即日対応",
  },
  {
    icon: "ri-map-pin-2-line",
    title: "大阪一筋の地域密着",
    desc: "2019年創業。大阪の現場を知り尽くした地域密着の警備会社",
  },
];

export default function StrengthsSection() {
  const { ref, isVisible } = useScrollReveal<HTMLDivElement>(0.1);

  return (
    <section id="strengths" className="bg-navy py-20 md:py-28 relative overflow-hidden">
      <div className="absolute inset-0 opacity-5 pointer-events-none">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_1px_1px,white_1px,transparent_0)] bg-[length:24px_24px] pointer-events-none" />
      </div>

      <div ref={ref} className="w-full px-4 md:px-8 max-w-6xl mx-auto relative z-10">
        <div className="text-center mb-14">
          <span className="text-gold text-sm tracking-[4px] font-bold block mb-2">WHY GRANSTARK</span>
          <h2 className="text-2xl md:text-3xl font-bold text-white">選ばれる理由</h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {strengths.map((item, i) => (
            <div
              key={item.title}
              className={`bg-white/8 rounded-2xl p-6 md:p-8 border border-white/10 transition-all duration-700 hover:bg-white/12 hover:-translate-y-2 ${
                isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
              }`}
              style={{ transitionDelay: `${i * 120}ms` }}
            >
              <div className="w-14 h-14 rounded-full bg-gold/20 flex items-center justify-center mb-5">
                <span className="w-8 h-8 flex items-center justify-center text-gold">
                  <i className={`${item.icon} text-2xl`}></i>
                </span>
              </div>
              <h3 className="text-lg font-bold text-white mb-3">{item.title}</h3>
              <p className="text-sm text-gray-300 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <a
            href="/company#license"
            className="inline-flex items-center gap-2 text-gold text-sm font-bold tracking-wide hover:text-white transition-colors duration-300 group"
          >
            <span className="whitespace-nowrap">詳細はこちら</span>
            <span className="w-5 h-5 flex items-center justify-center transition-transform duration-300 group-hover:translate-x-1">
              <i className="ri-arrow-right-line"></i>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}